import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Autocomplete } from "@mui/material";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import Button from "@mui/material/Button";
import { useParams, useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import "./FranchiseeUpdateComponent.css";

const FranchiseeUpdateComponent = (props) => {
  const { cohortId } = useParams();
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");

  // Filter warehouse list based on search input
  const filteredWarehouses = props.warehouseList
    ? props.warehouseList.filter(warehouse =>
      warehouse.name?.toLowerCase().includes(searchInput.toLowerCase()) ||
      warehouse.id?.toString().includes(searchInput)
    )
    : [];

  // Get the current warehouse object based on the warehouse ID in form data
  const selectedWarehouse = props.warehouseList?.find(
    wh => wh.id === props.formDataFranchisee?.warehouseId
  ) || props.formDataFranchisee?.warehouse || null;

  const goback = () => {
    navigate(-1);
  };

  return (
    <div className="franchisee-main">
      <Sidebar />

      <div className="franchisee-content">
        <div className="franchisee-header">
          <h2>
            <img
              onClick={goback}
              className="back-arrow"
              src={leftArrow}
              alt="Back"
            />{" "}
            Edit Franchisee
          </h2>
        </div>

        <div className="franchisee-form-container">
          <Box className="franchisee-form-box">
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={props.formDataFranchisee?.name || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />
            <TextField
              fullWidth
              label="Description"
              name="description"
              value={props.formDataFranchisee?.description || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />
            <TextField
              fullWidth
              label="Type"
              name="type"
              value={props.formDataFranchisee?.type || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />

            {/* Simplified Warehouse Dropdown with Search */}
            <Autocomplete
              style={{ width: "500px" }}
              options={filteredWarehouses}
              getOptionLabel={(option) => option && option.name ? `${option.name} (ID: ${option.id})` : ""}
              value={selectedWarehouse}
              onChange={(event, newValue) => {
                if (newValue) {
                  props.handleUpdateFranchisee({
                    target: {
                      name: "warehouseId",
                      value: newValue.id
                    }
                  });
                }
              }}
              onInputChange={(event, newInputValue) => {
                setSearchInput(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="mui-text-field"
                  label="Select Warehouse"
                  placeholder="Search by name or ID"
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <div style={{ fontWeight: 600, marginRight: "10px" }}>{option.name}</div>

                </li>
              )}
              noOptionsText="No warehouses found"
            />

            <TextField
              fullWidth
              label="Cohort ID"
              name="cohortId"
              value={props.formDataFranchisee?.cohortId || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
              InputLabelProps={{ shrink: true }}
              disabled
            />

            <TextField
              fullWidth
              label="Owner ID"
              name="ownerId"
              value={Number(props.formDataFranchisee?.ownerId) || ""}
              onChange={props.handleUpdateFranchisee}
              className="franchisee-input"
            />
          </Box>

          <Box className="franchisee-button-group">
            <Button variant="outlined" onClick={goback}>
              Back
            </Button>
            <Button variant="contained" onClick={props.handleApicallToUpdate}>
              Save
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default FranchiseeUpdateComponent;